module.exports = __webpack_public_path__ + "static/08 - ManchesterUni-17c1551f7e71d5f0953426b9f365ccf2.png";